import { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import {doc, getDoc} from "firebase/firestore";
import Api from "../utils/Api";

const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [userName, setUserName] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [hasPaid, setHasPaid] = useState(false);
    const [hasVip, setHasVip] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {

            if (user) {
                await setCurrentUser(user);

                const userDb = process.env.REACT_APP_FIREBASE_USER_DB;
                const userDocRef = doc(db, userDb, user.uid);
                const userDocSnap = await getDoc(userDocRef);
                if (userDocSnap.exists()) {
                    const userData = userDocSnap.data();
                    setUserName(userData.name || '');
                    setCustomerId(userData.customerID)
                } else {
                    setUserName('User');
                }
            }

            setLoaded(true);
        });

        return () => unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        checkPaymentExists();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId])

    const recheckPayment = async () => {
        if(currentUser) {
            const hasPaidData = await checkPaymentExists();
            setHasPaid(hasPaidData);
        }
    }

    const checkPaymentExists = async () => {
        setHasPaid(false)
        setHasVip(false)

        const data = await Api.checkSubscription(customerId)
        if(data.length > 0) {
            let activeSubs = data.filter(sub => (sub.status === "active" || sub.status === "trialing"));

            const vipSubs = activeSubs.filter(sub => {
                return sub.plan.id === process.env.REACT_APP_STRIPE_VIP_PRICE_ID
            });

            const vipOnlySubs = activeSubs.filter(sub => {
                return sub.plan.id === process.env.REACT_APP_STRIPE_VIP_ONLY_PRICE_ID
            });

            if(vipOnlySubs.length > 0){
                activeSubs = activeSubs
                    .filter(sub => sub.plan.id !== process.env.REACT_APP_STRIPE_VIP_ONLY_PRICE_ID)
            }

            if (activeSubs.length > 0) {
                setHasPaid(true)
            }

            if (vipSubs.length > 0 || vipOnlySubs.length > 0) {
                setHasVip(true)
            }
        }
    };

    const logout = async () => {
        await auth.signOut();
        await setCurrentUser(null);
        await setCustomerId('');
        await setUserName('');
        await setHasPaid(false);
        await setHasVip(false);
    }

    const value = {
        currentUser,
        setCurrentUser,
        userName,
        customerId,
        hasPaid,
        setHasPaid,
        hasVip,
        setHasVip,
        logout,
        recheckPayment,
        loaded,
    };


    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};